import { Component, OnInit, ViewChild } from '@angular/core';
import { NgForm } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { forkJoin } from 'rxjs';
import { DictionaryClientDataRequestType } from 'src/app/extensions/constants/dictionaryConstants/dictionaryConstants';
import { DictionaryAPIService } from 'src/app/extensions/services/api/dictionary-api.service';
import { PartnerAPIService } from 'src/app/extensions/services/api/partner-api.service';
import { FilesHandler } from '../../utils/files-handler';
import { GlobalService } from 'src/app/extensions/services/global.service';
import { isNotEmpty } from 'src/app/extensions/utilities';
import { SIGNAL_ITEM_KEY } from 'src/app/extensions/constants/commonConstants';
@Component({
  selector: 'app-add-associates-request',
  templateUrl: './add-associates-request.component.html',
  styleUrls: ['./add-associates-request.component.scss'],
  standalone: false,
})
export class AddAssociatesInformationRequestComponent implements OnInit {
  @ViewChild('form') public form: NgForm;

  clientDataRequestSaveModel: app.models.ClientDataRequestSaveModel = {
    associates: [{}],
    documentsAttached: [],
  } as app.models.ClientDataRequestSaveModel;

  private stateSignalItem: any;

  constructor(
    private _globalService: GlobalService,
    private _router: Router,
    private _dictionaryService: DictionaryAPIService,
    private _partnerService: PartnerAPIService,
    public _filesHandler: FilesHandler,
    public _activatedRoute: ActivatedRoute
  ) {
    this.stateSignalItem = this._globalService.getSignalItem(SIGNAL_ITEM_KEY.RQST_CLIENT_DATA);

    if (isNotEmpty(this.stateSignalItem)) {
      this.clientDataRequestSaveModel = this.stateSignalItem.data as app.models.ClientDataRequestSaveModel;
    }
  }

  ngOnInit(): void {
    if (!isNotEmpty(this.stateSignalItem)) {
      this.loadData();
    }
  }

  loadData() {
    let source = forkJoin([this._partnerService.getCompanyInfo(), this._dictionaryService.getClientDataRequestTypes()]);
    source.subscribe(([clientData, dictionaryClientDataRequestTypes]) => {
      if (clientData.data) {
        this.clientDataRequestSaveModel.partnerExternalEntityId = clientData.data.partnerExternalEntityId;
      }

      if (dictionaryClientDataRequestTypes.data) {
        let associatesRequestType = dictionaryClientDataRequestTypes.data.find(
          x => x.code == DictionaryClientDataRequestType.Associates
        );
        if (associatesRequestType) {
          this.clientDataRequestSaveModel.dictionaryClientDataRequestTypeId = associatesRequestType.id;
          this.clientDataRequestSaveModel.description = associatesRequestType.description;
        }
      }
    });
  }

  removeAsscociateHandler(associateIndex: number) {
    this.clientDataRequestSaveModel.associates.splice(associateIndex, 1);
  }

  sendRequestCofirmationHandler() {
    if (this.form.invalid) {
      return;
    }

    this.stateSignalItem = {
      data: this.clientDataRequestSaveModel,
      routePath: this._activatedRoute.snapshot.routeConfig.path,
    };
    this._globalService.setSignalItem(SIGNAL_ITEM_KEY.RQST_CLIENT_DATA, this.stateSignalItem);
    this._router.navigate(['requests/client-data/new/request-preview']);
  }

  addPersonHandler() {
    this.clientDataRequestSaveModel.associates.push({} as app.models.ClientDataRequestsAssociateModel);
  }

  redirectFieldSelectionHandler() {
    this._router.navigate(['requests/client-data/new']);
  }
}
